import React from 'react';
import { Info, X } from 'lucide-react';
import { PAGE } from './copy';

export function OffRampTipBanner({ onDismiss }: { onDismiss: () => void }) {
    return (
        <div
            className="flex items-start gap-2 rounded-lg border border-primary/25 bg-primary/5 px-3 py-2.5 text-sm text-foreground"
            role="status"
        >
            <Info className="w-4 h-4 text-primary shrink-0 mt-0.5" />
            <p className="flex-1 text-xs sm:text-sm">{PAGE.tip}</p>
            <button
                type="button"
                onClick={onDismiss}
                className="text-muted-foreground hover:text-foreground p-0.5"
                aria-label="Dismiss tip"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}
